/**
 * Created by Administrador on 27/07/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('cargoReceivedOffice', {
                parent: 'app',
                url: '/cargoReceivedOffice',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoReceivedOffice.html',
                        controller: 'cargoReceivedOfficeCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoReceivedOffice')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'branchOffices': ['branchOfficeService', function(branchOfficeService){
                                return branchOfficeService.getBranchOfficesCargo(true)
                            }]
                        }
                    }
                }
            })
            .state('cargoReceivedRegion', {
                parent: 'app',
                url: '/cargoReceivedRegion',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoReceivedRegion.html',
                        controller: 'cargoReceivedRegionCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoReceivedRegion')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'branchOffices': ['branchOfficeService', function(branchOfficeService){
                                return branchOfficeService.getBranchOfficesCargo(true)
                            }]
                        }
                    }
                }
            })
            .state('cargoReceivedDestinations', {
                parent: 'app',
                url: '/cargoReceivedDestinations',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoReceivedDestinations.html',
                        controller: 'cargoReceivedDestinationsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoReceivedDestinations')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }]
                        }
                    }
                }
            })
            .state('cargoComingStock', {
                parent: 'app',
                url: '/cargoComingStock',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/comingStock.html',
                        controller: 'cargoComingStockCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoComingStock')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('cargoNotDelivered', {
                parent: 'app',
                url: '/cargoNotDelivered',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoNotDelivered.html',
                        controller: 'cargoNotDeliveredCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoNotDelivered')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type: [function () {
                                return 'cargoNotDelivered';
                            }]
                        }
                    }
                }
            })
            .state('consigneePhone', {
                parent: 'app',
                url: '/consigneePhone',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoNotDelivered.html',
                        controller: 'cargoNotDeliveredCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('consigneePhone')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type: [function () {
                                return 'consigneePhone';
                            }]
                        }
                    }
                }
            })
            .state('cargoLow', {
                parent: 'app',
                url: '/cargoLow',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoLowAnnulment.html',
                        controller: 'cargoLowAnnulmentCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoLow')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type: [function () {
                                return 'cargoLow';
                            }]
                        }
                    }
                }
            })
            .state('cargoAnnulment', {
                parent: 'app',
                url: '/cargoAnnulment',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoLowAnnulment.html',
                        controller: 'cargoLowAnnulmentCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoAnnulment')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type: [function () {
                                return 'cargoAnnulment';
                            }]
                        }
                    }
                }
            })
            .state('cargoRefund', {
                parent: 'app',
                url: '/cargoRefund',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoLowAnnulment.html',
                        controller: 'cargoLowAnnulmentCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoRefund')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type: [function () {
                                return 'cargoRefund';
                            }]
                        }
                    }
                }
            })
            .state('cargoDelivered', {
                parent: 'app',
                url: '/cargoDelivered',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargoReceived/cargoDelivered.html',
                        controller: 'cargoDeliveredCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoReceivedReport('cargoDelivered')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReceived']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            });
    }
})();
